import { render, staticRenderFns } from "./center-top.vue?vue&type=template&id=4aaaa886&scoped=true&"
import script from "./center-top.vue?vue&type=script&lang=js&"
export * from "./center-top.vue?vue&type=script&lang=js&"
import style0 from "./center-top.vue?vue&type=style&index=0&id=4aaaa886&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaaa886",
  null
  
)

export default component.exports